import type { ContentBlock, Page } from '#content/shared/@types/generated/cms/graphql-schema-types'

import { useState } from '#app'
import { AcknowledgementPage, AcknowledgementState } from '~/components/Acknowledgement/types'

export const useAcknowledgement = () => {
  const showAcknowledgementModal = useState(
    AcknowledgementState.showAcknowledgementModal,
    () => false,
  )

  const { load: fetchUser } = useUserDataLazyQuery({
    fetchPolicy: 'cache-first',
  })

  const { isLoggedIn } = useAuth()
  const { log } = useDatadog()
  const { fetchPage } = useContent()

  const getAcknowledgementDate = (data: Page) => {
    const dateString = (data?.contentBlocksCollection?.items[0] as ContentBlock)?.acknowledgmentDate

    return new Date(dateString || '')
  }

  const checkAcknowledgementStatus = async () => {
    if (!isLoggedIn.value) return

    const privacyPolicyData = await fetchPage(AcknowledgementPage.PrivacyPolicy)
    const termsAndConditionsData = await fetchPage(AcknowledgementPage.TermsAndConditions)

    const acknowledgementDatePrivacyPolicy = getAcknowledgementDate(privacyPolicyData)
    const acknowledgementDateTermsAndConditions = getAcknowledgementDate(termsAndConditionsData)

    const acknowledgementDates = [
      acknowledgementDatePrivacyPolicy.getTime(),
      acknowledgementDateTermsAndConditions.getTime(),
    ].filter((d) => !isNaN(d))

    const latestAcknowledgementDate = Math.max(...acknowledgementDates)

    try {
      const user = await fetchUser()
      if (!user) return

      const lastAcknowledgedTermsAndConditionsDateString =
        user?.player?.lastAcknowledgedTermsAndConditions

      const lastAcknowledgedTermsAndConditionsDate = lastAcknowledgedTermsAndConditionsDateString
        ? new Date(lastAcknowledgedTermsAndConditionsDateString).getTime()
        : null

      if (
        lastAcknowledgedTermsAndConditionsDate &&
        latestAcknowledgementDate > lastAcknowledgedTermsAndConditionsDate
      ) {
        showAcknowledgementModal.value = true
      }
    } catch (error) {
      log('error', {
        component: 'composables/acknowledgement.ts',
        message: 'Fetching user data for acknowledgement check failed',
        messageContext: { error },
      })
    }
  }

  return {
    checkAcknowledgementStatus,
    showAcknowledgementModal,
  }
}
